module.exports = __webpack_public_path__ + "static/svl-62ec64bafc5cd4f3e24735f8727d6890.mp4";